import { useMutation } from "urql";

import { GenerateJwtTokenDocument } from "../../../graphql/generated.ts";

export function useGenerateJwtToken() {
  return useMutation(GenerateJwtTokenDocument);
}
